import { SYSMAN_SERVICES } from './services/index';

export const SYSMAN_PROVIDERS: Array<any> = [
  ...SYSMAN_SERVICES
];



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/app.providers.ts